import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locale'
})
export class LocalePipe implements PipeTransform {

  transform(value: string): string {
    return value;
  }

}
